import React, { useState, useRef } from 'react';
import { Row, Col, Button, Typography, Spin } from 'antd';
import axios from 'axios';
import { LoadingOutlined } from '@ant-design/icons';
const PhonePage = (props) => {
    const { Paragraph } = Typography;
    const scrollContainerRef = useRef(null);
    const antIcon = <LoadingOutlined data style={{ color: '#ffffff' }} />;
    const [spinning, setSpinning] = useState(false);
    const [showTips, setShowTips] = useState(false);
    const [pcTip1, setPcTip1] = useState('');
    const [pcTip2, setPcTip2] = useState('');
    const [pcTip3, setPcTip3] = useState('');
    const [pcTip4, setPcTip4] = useState('');
    const [pcTip5, setPcTip5] = useState('');
    const [pcTip6, setPcTip6] = useState('');
    const [pcTip7, setPcTip7] = useState('');
    const [showWeiXinTop, setShowWeiXinTop] = useState(false);

    React.useEffect(() => {
        var lang = (navigator.systemLanguage ? navigator.systemLanguage : navigator.language);
        if (lang.substring(0, 2) === 'zh') {
            setPcTip1('1.请勿关闭网页，下载后到主屏幕查看是否安装成功')
            setPcTip2(require('../../../../static/img/icon_untrusted_enterprise_developer_cn.gif'))
            setPcTip3('下载安装')
            setPcTip4('更新日志')
            setPcTip5('下载后请在主屏幕查看（部分手机需要手动安装）')
            setPcTip6(require('../../../../static/img/icon_weixin_tips2.png'))
            setPcTip7('2.安装成功后需要在设置 > 通用 > VPN与设备管理中信任企业级开发者')

        } else {
            setPcTip1('1.Please keep this webpage open and check your home screen to confirm the installation.')
            setPcTip2(require('../../../../static/img/icon_untrusted_enterprise_developer_es.gif'))
            setPcTip3('Download')
            setPcTip4('What\'s New')
            setPcTip5('Please check on the home screen after downloading (some phones may require manual installation).')
            setPcTip6(require('../../../../static/img/icon_weixin_tips2_es.png'))
            setPcTip7('2.After installation, navigate to Settings > General > VPN & Device Management and trust the ENTERPRISE App.')
        }
        if (navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 ||
            typeof navigator.wxuserAgent !== 'undefined') {
            setShowWeiXinTop(true)
        }
    }, [])
    function downLoad() {
        setSpinning(true)
        axios.get(props.dlUrl,
            {
                responseType: 'blob',
                onDownloadProgress: (evt) => {
                    console.log("progressEvent===", parseInt((evt.loaded / evt.total) * 100))
                }
            }
        ).then((res) => {
            let name = props.appName + props.appVersion
            console.log("res===", res);
            const blob = new Blob([res.data]);
            if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                elink.download = name;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
                setSpinning(false)
            } else {
                // IE10+下载
                navigator.msSaveBlob(blob, name);
                setSpinning(false)
            }
        }).catch((err) => {
            console.log("下载错误", err)
            setSpinning(false)
        })

    }
    function showLoading() {
        setSpinning(true)
        setTimeout(function () {
            setShowTips(true)
            if(props.appPlatform === 'IOS'){
                scrollTo100vh()
            }
        }, 5000)
    }
    const scrollTo100vh = () => {
        if (scrollContainerRef.current) {
          const height = window.innerHeight;
          scrollContainerRef.current.scrollTo({
            top: height * 0.97,
            behavior: 'smooth',
          });
        }
      };
    
    return (
        <div style={{ position: 'relative', display: props.isPhone ? "" : "none", width: '100%', }}>
            <div  style={{ height: '6vh', width: '100%', }}>
                <Row style={{ height: '5vh',display: 'flex', alignItems: 'center'  }}>
                    <img src={require('../../../../static/img/ic-home-logo.png')} alt="logo"
                        style={{  marginLeft: '10px', height: '20px' }} />
                </Row>
                <div style={{ backgroundColor: '#FF5300', width: '100vw', height: '1px', marginTop: '5px' }}></div>
            </div>
            <div ref={scrollContainerRef} style={{ overflowY: 'scroll', height: '94vh', width: '100%', }}>
                <div style={{ display: props.isPhone ? "" : "none", height: '94vh', width: '100%', }}>
                    <div style={{ width: '100vw', display: 'flex', justifyContent: 'center', }}>
                        <img src={props.appIcon} alt="logo"
                            style={{ height: '100px', borderRadius: '10px', marginTop: '100px' }} />
                    </div>

                    <div style={{ marginLeft: '10vw', width: '80vw' }}>
                        <Row style={{ marginTop: '27px', display: 'flex', justifyContent: 'center', }}>
                            <Col>
                                <img src={props.appPlatformIcon} style={{ width: '30px', height: '30px' }}></img>
                            </Col>
                            <Col style={{ fontSize: '22px', color: '#3D3D3D', marginLeft: '5px' }}>
                                {props.appName}
                            </Col>
                        </Row>

                    </div>

                    <div style={{ marginTop: '25px', marginLeft: '25vw', backgroundColor: '#D8D8D8', width: '50vw', height: '1px' }}></div>
                    <div style={{ width: '100vw', display: 'flex', justifyContent: 'center', }}>
                        <div>
                            <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'center', fontSize: '14px', color: '#A8A8A8' }}>{props.appVersion}</div>
                            <div style={{ display: 'flex', justifyContent: 'center', fontSize: '14px', color: '#A8A8A8' }}>{props.appUpTime}</div>
                        </div>
                    </div>
                    <div style={{ width: '100vw', display: showTips ? 'none' : '', }}>
                        <div style={{ width: '100vw', display: 'flex', justifyContent: 'center', }}>

                            <Button href={props.dlUrl} onClick={() => showLoading()}
                                style={{
                                    visibility: props.isShow ? 'visible' : 'hidden',
                                    marginTop: '31px', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '140px', height: '44px',
                                    fontSize: '18px', color: '#fff', backgroundColor: '#FF5300', borderRadius: '20px'
                                }}>
                                <div style={{ display: spinning ? 'none' : '' }}>
                                    {pcTip3}
                                </div>
                                <Spin spinning={spinning} indicator={antIcon}></Spin>
                            </Button>
                        </div>
                        <div style={{ width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                            <div style={{
                                display: (!props.isShow && props.dlUrl != null) ? '' : 'none',
                                fontSize: '16px', color: '#FF5300'
                            }}>
                                {props.onlyDevice}
                            </div>
                        </div>

                    </div>
                    <div style={{
                        width: '100vw',
                        visibility: showTips&&props.appPlatform !== 'IOS' ? 'visible' : 'hidden',
                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                        color: '#EC602A', fontSize: '16px', marginTop: '31px', textAlign: 'center',
                    }}>
                        {pcTip5}
                    </div>

                </div>
                <div style={{ width: '100vw', display: props.appPlatform === 'IOS' ? '' : 'none', }}>
                    <div style={{
                        width: '100vw', textAlign: 'center',
                        display: 'flex', justifyContent: 'center', fontSize: '18px', color: '#353535',
                        paddingLeft:'25px',paddingRight:'25px',
                    }}>
                        {pcTip1}
                    </div>
                    <img style={{ width: '70vw', marginLeft: '15vw',marginBottom:'35px',marginTop:'10px' }}
                        src={require('../../../../static/img/icon_ios_app_installing.webp')} />
                     <div style={{
                        width: '100vw', textAlign: 'center',
                        display: 'flex', justifyContent: 'center', fontSize: '18px', color: '#353535',
                        paddingLeft:'25px',paddingRight:'25px',
                    }}>
                         {pcTip7}
                    </div>
                    <img style={{ width: '70vw', marginLeft: '15vw' }}
                        src={pcTip2} />

                </div>

                <div style={{ marginTop: '20vh', marginLeft: '25vw', backgroundColor: '#D8D8D8', width: '50vw', height: '1px' }}></div>

                <div style={{ marginLeft: '28vw', marginTop: '20px', fontSize: '14px', color: '#A8A8A8' }}>
                    {pcTip4}
                </div>
                <Paragraph style={{ marginLeft: '28vw', width: '44vw', fontSize: '14px', color: '#A8A8A8', marginBottom: '20px', }}>
                    {props.description}
                </Paragraph>

                <div style={{
                    display: showWeiXinTop ? '' : 'none', position: 'absolute', top: 0,
                    height: '100vh', width: '100%',
                }}>
                    <div style={{
                        position: 'fixed', top: 0,
                        height: '100vh', width: '100%', background: 'rgba(0, 0, 0, 0.7)',
                    }}>
                        <div style={{
                            display: 'flex', justifyContent: 'right',
                        }}>
                            <img style={{ width: '50px', height: '62px', marginRight: '30px' }} src={require('../../../../static/img/icon_weixin_tips1.png')} />
                        </div>
                        <div style={{
                            display: 'flex', justifyContent: 'right',
                        }}>
                            <img style={{ height: '48px', marginRight: '77px' }} src={pcTip6} />
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )

}

export default PhonePage